import { createAuthClient } from 'better-auth/react';
import { magicLinkClient } from 'better-auth/client/plugins';

type AuthClientOptions = {
  baseURL: string;
  plugins: [ReturnType<typeof magicLinkClient>];
};

const authClientOptions: AuthClientOptions = {
  baseURL: typeof window !== 'undefined' ? window.location.origin : '',
  plugins: [magicLinkClient()],
};

type AuthClient = ReturnType<typeof createAuthClient<AuthClientOptions>>;

export const authClient: AuthClient = createAuthClient(authClientOptions);
